import gql from 'graphql-tag'

export const getProDesignProject = gql`
  query getProDesignProject(
      $projectId: Int
    ) {
    project: getProDesignProject(projectId: $projectId) {
      id
      shortId: short_id
      createdAt: created_at
      name
      status
      teamSize: team_size
      deliveryDate: delivery_date
      phone
      shared
      imported
      members {
        id
        shortId: short_id
        userId: user_id
        firstName: first_name
        lastName: last_name
        dateInvited: date_invited
        dateAdded: date_added
        role
        projectId: project_id
        email
      }
      notes
      locker {
        id
        name
        image
        shortId: short_id
        createdAt: created_at
        product {
          id
          code
          active
          yotpoId: yotpo_id
          type: name
          weight
          onlyProDesign: only_pro_design
          description: short_description
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
        }
      }
      inspiration {
        id
        image
        assetType: asset_type
      }
      palette {
        id
        name
        primary: primary_color
        accent1: accent_1
        accent2: accent_2
        accent3: accent_3
        accent4: accent_4
      }
      files {
        name
        fileUrl: file_url
        type
      }
      user {
        name: first_name
        lastName: last_name
        email
        accountManager {
          firstName: first_name
          lastName: last_name
          email
        }
      }
      designs(showArchivedItems: false, fromCustomer: true) {
        designSerialId: design_serial_id
        designId: design_id
        id: short_id
        name
        code
        createdAt: created_at
        updatedAt: updated_at
        image
        status
        notifications
        inReview: in_review
        proDesign: pro_design
        proCertified: pro_certified
        stitchingValue: flatlock
        predyedName: predyed_name
        stitchingName: flatlock_code
        zipperColor: zipper_color
        zipper2Color: zipper2_color
        bindingColor: binding_color
        bibColor: bib_brace_color
        testPrintData(fromApprovalCenter: true) {
          shortId: short_id
        }
        product {
          id
          productId: id
          code
          yotpoId: yotpo_id
          name
          type: name
          discontinued
          active
          description: short_description
          shortDescription: short_description
          collections
          isTopProduct
          weight
          hideFitStyles: hide_fit_styles
          sizeTag: size_tag
          youthCombined: youth_combined
          customizable: design_center
          retailMen: men_retail
          retailWomen: women_retail
          genders {
            id
            name: gender
          }
          fitStyles {
            id
            info
            name: description
          }
          priceRange {
            quantity
            price
            abbreviation
            shortName: short_name
          }
          images: original_pictures {
            front: front_image
            thumbnail: thumbnail
            back: back_image
            left: left_image
            right: right_image
            genderId: gender_id
          }
          sizeRange: size_range {
            id
            name
            isYouth: is_youth
          }
        }
        lastTask: lastTaskCustomer {
          date
          type
        }
      }
    }
  }
`

export const GetColorsQuery = gql`
  query GetColors {
    colorsResult: getColors {
      colors
    }
  }
`

export const deleteProItemMutation = gql`
  mutation deleteProItem($itemId: String!) {
    deleteProItem(itemId: $itemId) {
      message
    }
  }
`

export const deleteProjectMutation = gql`
  mutation deleteProject($projectId: String!) {
    deleteProject(projectId: $projectId) {
      message
    }
  }
`

export const sendInvitationsMutation = gql`
  mutation sendInvitations(
    $projectId: String!
    $emails: [String]!
    $projectItemId: String!
  ) {
    sendInvitations(
      projectId: $projectId
      emails: $emails
      projectItemId: $projectItemId
      isProject: true
    ) {
      message
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProDesignProjectDetails/data.ts